module.exports = __webpack_public_path__ + "img/4.ac7ee982.png";